<div *ngIf="loadComplete">
    <div class="border-div" *ngIf="(authService.Admin() || authService.SuperAdmin() || authService.Broker() || (authService.DataEntryStaff() && propertyNotesList?.length > 0))">
        <div class="clearfix">
            <div class="data-right">
                <h2 class="mainhead">
                    <span class="text">B+E Notes</span>
                    <span class="tag-01" *ngIf="(authService.DataEntryStaff() || authService.DataEntryStaff()) && unResolvedFlag > 0">
                        Unresolved Flag <span class="flg">{{unResolvedFlag}}</span>
                    </span>
                </h2>
                <div class="like-view-div" *ngIf="(authService.Admin() || authService.Broker() || authService.SuperAdmin())">
                    <!--<p style="cursor:pointer" >+ Notes</p>-->
                    <button tooltip="Add Note" [disabled]="IsPDeleted" placement="left" (click)="openPropertyNotesModal(propertyNotes, 'panlestyle')" class="btn  btn-circle btn-green margin-bottom dropdown-toggle" type="button" aria-haspopup="true">
                        <i _ngcontent-c1="" aria-hidden="true" class="fa fa-plus icon"></i>
                    </button>
                </div>
            </div>
            <ul class="note-list cf">
              <li *ngFor="let item of propertyNotesList" [ngClass]="{'flaged-note':item.IsFlag && !item.IsResolved}">
                <div class="btn-wrap text-right">
                  <a placement="left" tooltip="Resolve Note" class="circle-btn" *ngIf="(authService.Admin()|| authService.SuperAdmin() || authService.DataEntryStaff()) && item.IsFlag && !item.IsResolved && item.UserId != user.Id" (click)="openRemoveNoteModal(resolveNote,item.Id)" href="javascript:void(0);"><i class="fa fa-check" aria-hidden="true"></i></a>
                  <a placement="left" tooltip="Remove Note" class="circle-btn" *ngIf="((authService.Admin()||authService.SuperAdmin()) && item.TypeId != 2752)" (click)="openRemoveNoteModal(removeNote,item.Id)" href="javascript:void(0);"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                </div>
                <p><i *ngIf="item.IsFlag || item.TypeId == 2752" style="color: red;margin-right: 10px;font-size: 16px;" [ngStyle]="{'color': item.IsResolved ? 'gray':'red' }" class="icon icon-flag"></i>{{item.Note}}</p>
                <p><i class="fa fa-user-circle-o" aria-hidden="true"></i> {{item.UserName}} {{Validation.convertUTCDateToLocalDate(item.CreatedDate)| date:'MM/dd/yyyy h:mm aa'}}</p>
                <p *ngIf="item.IsResolved"><b>Resolved : </b> {{item.ResolvedBy}} {{Validation.convertUTCDateToLocalDate(item.ResolvedDate)| date:'MM/dd/yyyy h:mm aa'}}</p>

              </li>
            </ul>
            <div class="nodata" *ngIf="propertyNotesList?.length == 0">
                <i class="icofont icofont-warning icon"></i>
                <p>No Notes Added</p>
            </div>
            <div class="text-right margin-bottom-20 margin-top-20" *ngIf="propertyNotesListAll?.length > 3">

                <a class="bluelink" *ngIf="showLoadMoreNoteBtn" (click)="GetPropertyNotes(0)">Load More Notes</a>
                <a class="bluelink" *ngIf="!showLoadMoreNoteBtn" (click)="GetPropertyNotes(3)">Hide Notes</a>
            </div>
        </div>
    </div>
</div>
<ng-template #propertyNotes>
    <div class="modal-header">
        <h4 class="modal-title pull-left">B+E Notes</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="form-label">Notes</label>
            <textarea class="form-control property-description" placeholder="Enter Notes..." #notes="ngModel" maxlength="500" [(ngModel)]="addPropertyNote.Note" rows="3"></textarea>
            <p class="redtext" *ngIf="(isSubmit && Validation.IsinValid(addPropertyNote.Note))">Notes is required </p>
        </div>
        <label class="custom-checkbox margin-right-20 margin-bottom-0" for="checkboxFlag">
            <input type="checkbox" [(ngModel)]="addPropertyNote.IsFlag" id="checkboxFlag">Flag Admin
            <i></i>
        </label>
        <div class="text-right">
            <button type="button" (click)="modalRef.hide()" class="btn btn-default btn-lg">Cancel</button>
            <button type="button" (click)="onAddNotes();" [disabled]="disableBtn" class="btn btn-success btn-lg">Add Notes</button>
        </div>
    </div>

</ng-template>

<ng-template #removeNote>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Remove Note</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefNote.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Are you sure to remove this note ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefNote.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="onRemoveNote(selectedNote);modalRefNote.hide();">Remove</button>
        </div>
    </div>
</ng-template>


<ng-template #resolveNote>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Resolve Note</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefNote.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Are you sure to mark this flag as resolved ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefNote.hide()">Cancel</button>
            <button class="btn btn-lg btn-primary" (click)="onResolveFlag(selectedNote);modalRefNote.hide();">Resolve</button>
        </div>
    </div>
</ng-template>
